module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none",
      "background": "rgba(255, 255, 255, 0.7)",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  })]), _vm._v(" "), (!_vm.telaProjeto) ? _c('legend', {
    staticStyle: {
      "background-color": "#fcfcfc"
    }
  }, [_vm._v("\n        Cadastro de ODS\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editando && !_vm.detalhamento) ? _c('div', {
    staticClass: "ods-button-tag"
  }, [_c('i', {
    class: _vm.mostrarTodos ? 'fa fa-check-circle-o' : 'fa fa-star',
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(!_vm.mostrarTodos ? 'Favoritos Fundação BB' : 'Todos ODS') + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ods-cadastro-container"
  }, [(!_vm.editando && !_vm.detalhamento) ? _c('div', {
    staticClass: "ods-button-alterar-container"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.abrirEdicao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Editar Cadastro de ODS")]), _vm._v(" "), (this.odsCadastrado.length <= 0) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.buscarODSCadastro()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true",
      "title": "Buscar ODS cadastrado"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editando && !_vm.detalhamento) ? _c('div', {
    staticClass: "ods-search-input"
  }, [_c('multiselect', {
    staticClass: "multiselect-ods",
    attrs: {
      "options": _vm.baseODS,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": true,
      "custom-label": _vm.customLabel,
      "show-labels": false,
      "group-values": "metas",
      "group-label": "ods",
      "track-by": "descricao",
      "label": "numeroMeta",
      "placeholder": "Selecione ou Pesquise as Metas do ODS",
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(values) {
        return [_c('div', {
          staticClass: "ods-items-lista",
          domProps: {
            "innerHTML": _vm._s(_vm.customTag(values.values))
          }
        })]
      }
    }], null, false, 737918590),
    model: {
      value: (_vm.odsSelecionado),
      callback: function($$v) {
        _vm.odsSelecionado = $$v
      },
      expression: "odsSelecionado"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editando && !_vm.detalhamento) ? _c('b-container', {
    staticClass: "ods-table",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "idOds",
      fn: function(row) {
        return [_c('div', {
          class: 'cor-' + row.item.idOds
        }, [_c('img', {
          staticClass: "ods-img",
          attrs: {
            "src": _vm.getImageODS(row.item.idOds),
            "alt": "ODS IMG"
          }
        })])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.detalharLinha(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-label": "false"
          }
        }), _vm._v(" Detalhar")])]
      }
    }], null, false, 54715329)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.editando && !_vm.detalhamento) ? _c('div', {
    staticClass: "ods-button-cadastro-container-m"
  }, [(_vm.editando) ? _c('div', {
    staticClass: "ods-button-filtro"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.mudarVisualizacao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          " + _vm._s(_vm.mostrarTodos ? 'Mostrar Favoritos FBB' : 'Mostrar Todos ODS'))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.salvarODS()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelarEdicao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Cancelar")])]) : _vm._e(), _vm._v(" "), (_vm.detalhamento) ? _c('div', {
    staticClass: "detalhamento-ods-container"
  }, [_c('div', {
    staticClass: "detalhamento-ods-titulo",
    class: 'cor-' + this.itemDetalhamento.idOds
  }, [_c('div', [_c('img', {
    staticClass: "ods-img",
    attrs: {
      "src": _vm.getImageODS(this.itemDetalhamento.idOds),
      "alt": "ODS IMG"
    }
  })]), _vm._v("\n        " + _vm._s(this.itemDetalhamento.ods) + "\n      ")]), _vm._v(" "), _vm._l((this.itemDetalhamento.metas), function(meta) {
    return _c('div', {
      staticClass: "detalhamento-ods-meta"
    }, [_vm._v("\n        " + _vm._s(meta) + "\n      ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.detalhamento) ? _c('div', {
    staticClass: "ods-button-cadastro-container-m"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.detalhamento = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Voltar")])]) : _vm._e(), _vm._v(" "), _c('vue-snotify')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0af8226e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/odsMarcacao.vue
// module id = 1857
// module chunks = 1